import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { withProcedureWraper } from '..'
import { Routes } from '../../../AppRoutes'
import { Box } from '../../../components/box'
import { Icon } from '../../../components/icon'
import { Table } from '../../../modules/table'
import { LeaveRequestService } from '../../../services/leave-request/leaveRequest.service'
import { useSelector } from '../../../store/store'
import { getDDMMYYYFormat } from '../../../helper/dateTimeHelper'
import * as _ from "lodash";
import { requestStatus } from '../../../constants/statusConstants'
import ApprovalStatus from '../../../components/status/approvalStatus'

export const MyLeaveRequestPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;

  const getMyApprovedLeaveRequests = () => {
    return LeaveRequestService.getMyLeaveRequests(currentUserName, requestStatus.approved).then(res => {
      return { data: _.reverse(res), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  const getMyWatingLeaveRequests = () => {
    return LeaveRequestService.getMyLeaveRequests(currentUserName, requestStatus.submitted).then(res => {
      return { data: _.reverse(res), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  return (
    <div className="LeaveRequestPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureLeaveRequest.path)}>
              <Icon.ArrowLeft />
            </div>
            {'Đơn xin nghỉ phép'}
          </div>
        </div>
        <Box title="Đang chờ duyệt">
          <Table
            onRowClick={(item) => history.push(Routes.procedureLeaveRequestDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Thời gian nghỉ',
                render: (item) => <span>{
                  `Từ ${getDDMMYYYFormat(item.fields.eLeaveStartDate)} Đến ${getDDMMYYYFormat(item.fields.eLeaveEndDate)}`
                }
                </span>
              },
              {
                name: 'Tổng số ngày nghỉ',
                render: (item) => item.fields.eDuration
              },
              {
                name: 'Loại',
                render: (item) => item.fields.eLeaveType
              },
              {
                name: 'Lý do',
                render: (item) => item.fields.eLeaveReason
              },
              {
                name: 'Quyết định',
                render: (item) => <ApprovalStatus status={item.fields.eRquestStatus} />
              }
            ]}
            onFetchData={getMyWatingLeaveRequests}
          />
        </Box>
        <Box title="Đã nghỉ">
          <Table
            onRowClick={(item) => history.push(Routes.procedureLeaveRequestDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Thời gian nghỉ',
                render: (item) => <span>{
                  `Từ ${getDDMMYYYFormat(item.fields.eLeaveStartDate)} Đến ${getDDMMYYYFormat(item.fields.eLeaveEndDate)}`
                }
                </span>
              },
              {
                name: 'Tổng số ngày nghỉ',
                render: (item) => item.fields.eDuration
              },
              {
                name: 'Loại',
                render: (item) => item.fields.eLeaveType
              },
              {
                name: 'Lý do',
                render: (item) => item.fields.eLeaveReason
              },
              {
                name: 'Quyết định',
                render: (item) => <ApprovalStatus status={item.fields.eRquestStatus} />
              }
            ]}
            onFetchData={getMyApprovedLeaveRequests}
          />
        </Box>
      </div>
    </div>
  )
})